const style = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(13, 17, 23, 0.8)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    backdropFilter: "blur(5px)",
  },
  modal: {
    backgroundColor: "#161B22",
    borderRadius: "16px",
    border: "1px solid #30363D",
    width: "100%",
    maxWidth: "500px",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
  },
  header: {
    padding: "20px 24px",
    borderBottom: "1px solid #30363D",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "600",
    color: "#E6EDF3",
  },
  closeButton: {
    background: "transparent",
    border: "none",
    color: "#8B949E",
    fontSize: "24px",
    cursor: "pointer",
  },
  content: {
    padding: "24px",
    overflowY: "auto",
    color: "#C9D1D9",
  },
  formGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: "600",
    color: "#8B949E",
    marginBottom: "8px",
  },
  select: {
    width: "100%",
    backgroundColor: "#0D1117",
    border: "1px solid #30363D",
    borderRadius: "6px",
    color: "#E6EDF3",
    padding: "10px 12px",
    fontSize: "14px",
  },
  radioGroup: {
    display: "flex",
    gap: "20px",
    backgroundColor: "#0D1117",
    padding: "12px",
    borderRadius: "6px",
    border: "1px solid #30363D",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    cursor: "pointer",
  },
  summaryText: {
    backgroundColor: "rgba(88, 166, 255, 0.1)",
    padding: "12px",
    borderRadius: "6px",
    margin: "0 0 20px 0",
    fontSize: "14px",
    borderLeft: "3px solid #58A6FF",
  },
  searchInput: {
    width: "100%",
    backgroundColor: "#0D1117",
    border: "1px solid #30363D",
    borderRadius: "6px",
    color: "#E6EDF3",
    padding: "10px 12px",
    fontSize: "14px",
  },
  enterpriseList: {
    border: "1px solid #30363D",
    borderRadius: "6px",
    marginTop: "10px",
    maxHeight: "250px",
    overflowY: "auto",
  },
  listHeader: {
    padding: "10px 12px",
    borderBottom: "1px solid #30363D",
    backgroundColor: "#0D1117",
  },
  enterpriseItem: {
    padding: "10px 12px",
    borderBottom: "1px solid #30363D",
  },
  "enterpriseItem:last-child": {
    borderBottom: "none",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "14px",
    cursor: "pointer",
  },
  enterpriseName: {
    fontWeight: "600",
  },
  enterpriseCnpj: {
    fontSize: "12px",
    color: "#8B949E",
    display: "block",
  },
  noResults: {
    textAlign: "center",
    padding: "20px",
    color: "#8B949E",
    fontSize: "14px",
  },
  footer: {
    padding: "16px 24px",
    borderTop: "1px solid #30363D",
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
  },
  buttonPrimary: {
    backgroundColor: "#238636",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
  "buttonPrimary:disabled": {
    backgroundColor: "#2b3137",
    color: "#8B949E",
    cursor: "not-allowed",
  },
  buttonSecondary: {
    backgroundColor: "transparent",
    color: "#8B949E",
    border: "1px solid #30363D",
    borderRadius: "6px",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
};

export default style;
